import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import { fetchPostData } from "@/Components/hooks/Api";
import { Comman_changeArrayFormat, Comman_changeArrayFormat3 } from "@/Components/Common/ChangeArrayFormat";
import DatePicker from "react-datepicker";
import { AgencyContext } from "Context/Agency";
import { colourStyles, colourStylesNoReq } from "@/CADComponents/Utility/CustomStylesForReact";
import PropTypes from "prop-types";

const VINSection = ({ vehicleSectionState, setVehicleSectionState, handleVehicleSectionState, clearVehicleSectionState, stateList, suffixIdDrp, errorVehicleSectionState, handleErrorVehicleSectionState, clearErrorVehicleSectionState, plateTypeIdDrp, makeIdDrp }) => {
  const { datezone } = useContext(AgencyContext);

  useEffect(() => {
    const savedState = localStorage.getItem('nameSectionState');
    if (savedState) {
      setVehicleSectionState(JSON.parse(savedState));
    }
  }, []);


  return (
    <>
      <fieldset className="ncic-main-container">
        <legend className="ncic-legend">{'Vehicle Registration Transactions (RQ/RNQ)'}</legend>
        <p className="ncic-warning-text">{'DST is required and also enter any one of the following : (Plate No. and Plate Expires) or VIN.'}</p>

        <div className="ncic-form-container">
          {/* New line */}

          <div className="tab-form-row">
            <div className="col-11 tab-form-row-gap d-flex w-100">
              <div className="form-check d-flex align-items-center">
                <input
                  type="radio"
                  className="form-check-input mb-1"
                  id="RQ"
                  value="RQ"
                  checked={vehicleSectionState?.isByRQ_RNQ_QM === 'RQ'}
                  onChange={(e) => {
                    clearVehicleSectionState();
                    clearErrorVehicleSectionState();
                    handleVehicleSectionState("isByRQ_RNQ_QM", e.target.value);
                  }}
                />

                <label className="tab-form-label" htmlFor="RQ" style={{ cursor: 'pointer' }}>
                  (Plate No. and Plate Expires) or Vehicle (RQ)s
                </label>
              </div>
              <div className="form-check d-flex align-items-center">
                {/* <input className="form-check-input mb-1" type="radio" /> */}
                <input
                  type="radio"
                  className="form-check-input mb-1"
                  id="RNQ"
                  value="RNQ"
                  checked={vehicleSectionState?.isByRQ_RNQ_QM === 'RNQ'}
                  onChange={(e) => {
                    clearVehicleSectionState();
                    clearErrorVehicleSectionState();
                    handleVehicleSectionState("isByRQ_RNQ_QM", e.target.value);
                  }}
                />
                <label className="tab-form-label" htmlFor="RNQ" style={{ cursor: 'pointer' }}>
                  Name and DOB (RNQ)
                </label>
              </div>
            </div>
          </div>
          {/* RNQ fields – visible only when RNQ radio is selected */}
          {vehicleSectionState?.isByRQ_RNQ_QM === 'RNQ' && (
            <>
              {/* Row 1: Lastname | Firstname */}
              <div className="tab-form-row">
                <div className="col-2 d-flex align-self-center justify-content-end">
                  <label className="tab-form-label">
                    Lastname :
                    {errorVehicleSectionState?.lastName && (
                      <p style={{ color: 'red', fontSize: '11px', margin: '0px', padding: '0px' }}>Required</p>
                    )}
                  </label>
                </div>
                <div className="col-4 d-flex align-self-center">
                  <input
                    type="text"
                    className="form-control py-1 new-input requiredColor"
                    name="lastName"
                    placeholder="Lastname"
                    value={vehicleSectionState.lastName}
                    onChange={(v) => {
                      const value = v.target.value;
                      handleVehicleSectionState("lastName", value);
                      if (errorVehicleSectionState?.lastName) {
                        handleErrorVehicleSectionState("lastName", false);
                      }
                    }}
                  />
                </div>
                <div className="col-2 d-flex align-self-center justify-content-end">
                  <label className="tab-form-label">
                    Firstname :
                    {errorVehicleSectionState?.firstName && (
                      <p style={{ color: 'red', fontSize: '11px', margin: '0px', padding: '0px' }}>Required</p>
                    )}
                  </label>
                </div>
                <div className="col-4 d-flex align-self-center">
                  <input
                    type="text"
                    className="form-control py-1 new-input requiredColor"
                    name="firstName"
                    placeholder="Firstname"
                    value={vehicleSectionState.firstName}
                    onChange={(v) => {
                      const value = v.target.value;
                      handleVehicleSectionState("firstName", value);
                      if (errorVehicleSectionState?.firstName) {
                        handleErrorVehicleSectionState("firstName", false);
                      }
                    }}
                  />
                </div>
              </div>
              {/* Row 2: Middlename | Suffix */}
              <div className="tab-form-row">
                <div className="col-2 d-flex align-self-center justify-content-end">
                  <label className="tab-form-label">
                    Middlename :
                  </label>
                </div>
                <div className="col-4 d-flex align-self-center">
                  <input
                    type="text"
                    className="form-control py-1 new-input"
                    name="middleName"
                    placeholder="Middlename"
                    value={vehicleSectionState.middleName}
                    onChange={(v) => {
                      const value = v.target.value;
                      handleVehicleSectionState("middleName", value);
                    }}
                  />
                </div>
                <div className="col-2 d-flex align-self-center justify-content-end">
                  <label className="tab-form-label">
                    Suffix :
                    {errorVehicleSectionState?.suffix && (
                      <p style={{ color: 'red', fontSize: '11px', margin: '0px', padding: '0px' }}>Required</p>
                    )}
                  </label>
                </div>
                <div className="col-4">
                  <Select
                    styles={colourStylesNoReq}
                    placeholder="Select"
                    isClearable
                    options={suffixIdDrp}
                    value={vehicleSectionState?.suffix ? suffixIdDrp?.find((i) => i?.label === vehicleSectionState?.suffix) : ""}
                    onChange={(e) => {
                      handleVehicleSectionState("suffix", e?.label);
                      if (errorVehicleSectionState?.suffix) {
                        handleErrorVehicleSectionState("suffix", false);
                      }
                    }}
                  />
                </div>
              </div>
              {/* Row 3: DOB */}
              <div className="tab-form-row">
                <div className="col-2 d-flex align-self-center justify-content-end">
                  <label className="tab-form-label">
                    DOB :
                    {errorVehicleSectionState?.dob && (
                      <p style={{ color: 'red', fontSize: '11px', margin: '0px', padding: '0px' }}>Required</p>
                    )}
                  </label>
                </div>
                <div className="col-4 d-flex align-self-center">
                  <DatePicker
                    name='dob'
                    id='dob'
                    onChange={(v) => {
                      handleVehicleSectionState("dob", v);
                      if (errorVehicleSectionState?.dob) {
                        handleErrorVehicleSectionState("dob", false);
                      }
                    }}
                    selected={vehicleSectionState?.dob || ""}
                    dateFormat="MM/dd/yyyy"
                    isClearable={!!vehicleSectionState?.dob}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    autoComplete="off"
                    placeholderText="Select DOB"
                    maxDate={new Date(datezone)}
                    className="requiredColor"
                  />
                </div>
              </div>
            </>
          )}

          {/* RQ fields – visible only when RQ radio is selected */}
          {vehicleSectionState?.isByRQ_RNQ_QM === 'RQ' && (
            <>
              {/* Row 1: Plate Type | Plate State + Plate No. */}
              <div className="tab-form-row">
                <div className="col-2 d-flex align-self-center justify-content-end">
                  <label className="tab-form-label">
                    Plate Type :
                    {errorVehicleSectionState?.playType && (
                      <p style={{ color: 'red', fontSize: '11px', margin: '0px', padding: '0px' }}>Required</p>
                    )}
                  </label>
                </div>
                <div className="col-4">
                  <Select
                    styles={colourStylesNoReq}
                    placeholder="Select"
                    isClearable
                    options={plateTypeIdDrp}
                    value={vehicleSectionState?.playType ? plateTypeIdDrp?.find((i) => i?.shortCode === vehicleSectionState?.playType) : ""}
                    onChange={(e) => {
                      handleVehicleSectionState("playType", e?.shortCode);
                      if (errorVehicleSectionState?.playType) {
                        handleErrorVehicleSectionState("playType", false);
                      }
                    }}
                    menuPlacement="top"
                  />
                </div>
                <div className="col-2 d-flex align-self-center justify-content-end">
                  <label className="tab-form-label text-nowrap">
                    Plate State & No.
                    {(errorVehicleSectionState?.plateState || errorVehicleSectionState?.plateNo) && (
                      <p style={{ color: 'red', fontSize: '11px', margin: '0px', padding: '0px' }}>Required</p>
                    )}
                  </label>
                </div>
                <div className="col-2">
                  <Select
                    styles={colourStyles}
                    placeholder="State"
                    options={stateList}
                    value={vehicleSectionState?.plateState ? stateList?.find((i) => i?.label === vehicleSectionState?.plateState) : ""}
                    onChange={(e) => {
                      handleVehicleSectionState("plateState", e?.label);
                      if (errorVehicleSectionState?.plateState) {
                        handleErrorVehicleSectionState("plateState", false);
                      }
                    }}
                    menuPlacement="top"
                  />
                </div>
                <div className="col-2 d-flex align-self-center">
                  <input
                    type="text"
                    className="form-control py-1 new-input requiredColor"
                    name="plateNo"
                    placeholder="Number..."
                    value={vehicleSectionState.plateNo}
                    onChange={(v) => {
                      const value = v.target.value;
                      handleVehicleSectionState("plateNo", value);
                      if (errorVehicleSectionState?.plateNo) {
                        handleErrorVehicleSectionState("plateNo", false);
                      }
                    }}
                  />
                </div>
              </div>
              {/* Row 2: Plate Expires | VIN */}
              <div className="tab-form-row">
                <div className="col-2 d-flex align-self-center justify-content-end">
                  <label className="tab-form-label">
                    Plate Expires :
                    {errorVehicleSectionState?.platExpires && (
                      <p style={{ color: 'red', fontSize: '11px', margin: '0px', padding: '0px' }}>Required</p>
                    )}
                  </label>
                </div>
                <div className="col-4 d-flex align-self-center">
                  <DatePicker
                    name='platExpires'
                    id='platExpires'
                    onChange={(v) => {
                      handleVehicleSectionState("platExpires", v);
                      if (errorVehicleSectionState?.platExpires) {
                        handleErrorVehicleSectionState("platExpires", false);
                      }
                    }}
                    selected={vehicleSectionState?.platExpires || ""}
                    isClearable={!!vehicleSectionState?.platExpires}
                    showMonthDropdown
                    showYearDropdown
                    showYearPicker
                    dateFormat="yyyy"
                    maxDate={new Date(new Date().getFullYear() + 1, 11, 31)}
                    minDate={new Date(new Date().getFullYear() - 1, 0, 1)}
                    autoComplete="off"
                    placeholderText="Select Plate Expires"
                    className="requiredColor"
                  />
                </div>
                <div className="col-2 d-flex align-self-center justify-content-end">
                  <label className="tab-form-label">
                    VIN :
                    {errorVehicleSectionState?.VIN && (
                      <p style={{ color: 'red', fontSize: '11px', margin: '0px', padding: '0px' }}>Required</p>
                    )}
                  </label>
                </div>
                <div className="col-4 d-flex align-self-center">
                  <input
                    type="text"
                    className="form-control py-1 new-input"
                    name="VIN"
                    placeholder="VIN"
                    maxLength={17}
                    value={vehicleSectionState.VIN}
                    onChange={(v) => {
                      const value = v.target.value;
                      handleVehicleSectionState("VIN", value);
                      if (errorVehicleSectionState?.VIN) {
                        handleErrorVehicleSectionState("VIN", false);
                      }
                    }}
                  />
                </div>
              </div>
              {/* Row 3: Make | Manuf. Year */}
              <div className="tab-form-row">
                <div className="col-2 d-flex align-self-center justify-content-end">
                  <label className="tab-form-label">
                    Make :
                  </label>
                </div>
                <div className="col-4">
                  <Select
                    styles={colourStylesNoReq}
                    placeholder="Select"
                    isClearable
                    options={makeIdDrp}
                    value={vehicleSectionState?.make ? makeIdDrp?.find((i) => i?.value === vehicleSectionState?.make) : ""}
                    onChange={(e) => {
                      handleVehicleSectionState("make", e?.value);
                    }}
                    menuPlacement="top"
                  />
                </div>
                <div className="col-2 d-flex align-self-center justify-content-end">
                  <label className="tab-form-label">
                    Manufacturing Year :
                  </label>
                </div>
                <div className="col-4 d-flex align-self-center">
                  <input
                    type="text"
                    className="form-control py-1 new-input"
                    name="manuYear"
                    placeholder="Manufacturing Year"
                    value={vehicleSectionState.manuYear}
                    onChange={(v) => {
                      const value = v.target.value;
                      handleVehicleSectionState("manuYear", value);
                    }}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </fieldset>
    </>
  )
}

export default VINSection;

VINSection.propTypes = {
  vehicleSectionState: PropTypes.object.isRequired,
  setVehicleSectionState: PropTypes.func.isRequired,
  handleVehicleSectionState: PropTypes.func.isRequired,
  clearVehicleSectionState: PropTypes.func.isRequired,
  stateList: PropTypes.array.isRequired,
  suffixIdDrp: PropTypes.array.isRequired,
  errorVehicleSectionState: PropTypes.object,
  handleErrorVehicleSectionState: PropTypes.func,
};

VINSection.defaultProps = {
  errorVehicleSectionState: {},
  handleErrorVehicleSectionState: () => { },
  clearVehicleSectionState: () => { },
};
